import React, { useState, useMemo, useEffect, useRef } from "react";
import CustomTable from '../../common/CustomTable';
import { Select, DatePicker, Spin, message, Button, Dropdown, Space } from 'antd';
import { Timesheetapi } from "../../../middleware/interceptor";
import dayjs from 'dayjs';
import * as moment from 'moment';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import CryptoJS from 'crypto-js';
import customParseFormat from "dayjs/plugin/customParseFormat";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { BorderColor } from "@mui/icons-material";
import { DownOutlined, CheckOutlined } from '@ant-design/icons';
import { red } from "@mui/material/colors";


const { Option } = Select;
const { RangePicker } = DatePicker;


export default function ClientAllocation({ Secret_key, sidebor }) {

  const [selectedTimePeriod, setSelectedTimePeriod] = useState('week');
  const [loading, setloading] = useState(true)
  // let currentStartDate = dayjs().startOf(selectedTimePeriod)
  // let currentEndDate = dayjs().endOf(selectedTimePeriod);
  const [selectedDates, setSelectedDates] = useState([]);
  const [sDate, setSdate] = useState()
  const [eDate, setEdate] = useState()

  const [selectedWeekDates, setSelectedWeekDates] = useState([]);
  const [dateList, setDateList] = useState([]);
  const today = new Date();

  //For Project Report
  const [allClientList, setAllClientList] = useState([{ label: 'All', value: 1 }]);
  const [selectedClient, setSelectedClient] = useState();
  const [selectedClientDetails, setSelectedClientDetails] = useState([]);
  const [projectList, setProjectList] = useState([])
  const [totalHours, setTotalHours] = useState();
  const [clientChanged, setClientChanged] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const noDataWarning = () => {
    messageApi.open({
      type: 'warning',
      content: 'No data to download',
    });
  };
  const tableRef = useRef();


  const handleTimePeriodChange = (value) => {
    setSelectedTimePeriod(value)
  }

  //Function to change client change
  const handleClientChange = (value) => {
    // setloading(true);
    setSelectedClient(value);
  };


  const formatTime = (totalMinutes) => {
    if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };
  const formatTimes = (minutes) => {
    console.log(typeof minutes, "minutes")
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return dayjs().hour(hours).minute(mins);
  };

  useEffect(() => {

    if (sidebor) {
      // alert(sidebor)  
    }

  }, [sidebor]);


  //Dropdown and Functionalities for Status and Priority
  const [rawData, setRawData] = useState([]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "Client_name",
        header: "Clients",
        size: 150,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },
      {
        accessorKey: "projectName",
        header: "Projects",
        size: 150,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },
      {
        accessorKey: "comments_Date",
        header: "Comments Date",
        size: 150,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },
      {
        accessorKey: "Employee_Name",
        header: "Employees",
        size: 150,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },
      {
        accessorKey: "taskName",
        header: "Tasks",
        size: 200,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },
      {
        accessorKey: "CommentContent",
        header: "Comments",
        size: 300,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'left',
          },
        },
      },

      {
        accessorKey: "Hours",
        header: "Hours",
        size: 100,
        enableColumnActions: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          style: {
            textAlign: 'right',
          },
        },
      },
    ],
    [projectList]
  );



  const options = [
    { label: 'Day Report', value: 'date' },
    { label: 'Weekly Report', value: 'week' },
    { label: 'Monthly Report', value: 'month' },
    { label: 'Yearly Report', value: 'year' }
  ];

  useEffect(() => {
    const initialRender = async () => {
      if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year') {
        let currentStartDate = dayjs().startOf(selectedTimePeriod);
        let currentEndDate = dayjs().endOf(selectedTimePeriod);
        setSdate(currentStartDate.format("YYYY-MM-DD"));
        setEdate(currentEndDate.format("YYYY-MM-DD"));
        setSelectedDates([currentStartDate, currentEndDate])
        return;
      } else if (selectedTimePeriod === 'date') {
        let currentStartDate = dayjs().startOf('day');
        let currentEndDate = dayjs().endOf('day');
        setSdate(currentStartDate.format("YYYY-MM-DD"));
        setEdate(currentEndDate.format("YYYY-MM-DD"));
        setSelectedDates([currentStartDate, currentEndDate])
        return;
      } else if (selectedTimePeriod === 'week') {
        const weekDates = async () => {
          await handleWeekSelection([today]);
          console.log("ENTERED WEEK", handleWeekSelection([today]))
        }
        weekDates();
      }
    }
    initialRender();
  }, [selectedTimePeriod]);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Example usage:


  const getProjectLists = async (startDate, endDate) => {
    if (startDate && endDate) {

      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      console.log('setClientChanged', startDate, endDate)
      console.log("CLIENTS ERROR IN PROJECT LIST 1", selectedClient)
      setloading(true);
      try {
        const response = await Timesheetapi.get(
          `api/Projects/GetProjectReport?Sdate=${startDate}&Edate=${endDate}&Client_Id=${selectedClient}`
        );
        if (response.status === 200) {
          setSelectedClientDetails(response.data.Tasklist);
          console.error('status code', response.data.Tasklist);

        } else {
          console.error('Error: Received non-200 status code', response.status);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setloading(false);
      }
    }
  };

  useEffect(() => {
    const apiCall = async () => {
      if (sDate, eDate) {
        // setSelectedClient(1)
        await getProjectLists(sDate, eDate);
      }
    }
    apiCall();
  }, [sDate, eDate]);



  const handleDateChange = (date, dateString) => {
    setloading(true);
    if (date && date.length === 2) {
      const startDay = date[0];
      const endDay = date[1];

      if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year') {
        const startOfDay = startDay.startOf(selectedTimePeriod).format("YYYY-MM-DD");
        const endOfDay = endDay.endOf(selectedTimePeriod).format("YYYY-MM-DD");
        setSelectedDates([startDay, endDay]);
        setSdate(startOfDay);
        setEdate(endOfDay);
        return
      }
      if (selectedTimePeriod === 'date') {
        const startOfDay = startDay.startOf('day').format("YYYY-MM-DD");
        const endOfDay = endDay.endOf('day').format("YYYY-MM-DD");
        setSelectedDates([startDay, endDay]);
        setSdate(startOfDay);
        setEdate(endOfDay);
        return
      }
    }
  };


  // const formatDateToDDMMYYYY = (date) => {
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
  // };

  const handleWeekSelection = (selectedDates_, instance) => {
    if (instance) { instance.close(); }
    if (selectedDates_.length > 0) {

      const selectedTempDate = selectedDates_[0];
      const startOfWeek = new Date(selectedTempDate);
      const dayOfWeek = startOfWeek.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      setSelectedWeekDates([startOfWeek, endOfWeek]);
      setSdate(formatDateToDDMMYYYY(new Date(startOfWeek)));
      setEdate(formatDateToDDMMYYYY(new Date(endOfWeek)));
      console.log("ytrew", [formatDateToDDMMYYYY(new Date(startOfWeek)), formatDateToDDMMYYYY(new Date(endOfWeek))]);
      const newDateList = Array.from({ length: 7 }, (_, index) => {
        const date = new Date(startOfWeek);
        date.setDate(startOfWeek.getDate() + index);
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
        });
        console.log(formattedDate, 'selectedDates_')
        return {
          accessorKey: formattedDate,
          header: formattedDate,
        };
      });
      setDateList(newDateList);
    }

  };

  useEffect(() => {
    if (selectedTimePeriod === 'week') {
      const weekDates = async () => {
        await handleWeekSelection([today]);
        console.log("ENTERED WEEK", handleWeekSelection([today]))
      }
      weekDates()
    }

  }, [selectedTimePeriod]);


  const handleExportData = (data, sdate, edate, selectedTimePeriod) => {
    if (projectList.length > 0) {
      const clientname = selectedClient === 1 ? "All Clients" : allClientList.find(client => client?.value === selectedClient);
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Client Report');

      const formatDateRange = (start, end, type) => {
        const s = new Date(start);
        const e = new Date(end);
        switch (type) {
          case 'date':
            return `DATE: ${s.toDateString()} - ${e.toDateString()}`;
          case 'week':
            return `WEEK: ${s.toDateString()} - ${e.toDateString()}`;
          case 'month':
            return `MONTH: ${s.toLocaleString('en-US', { month: 'long', year: 'numeric' })} - ${e.toLocaleString('en-US', { month: 'long', year: 'numeric' })}`;
          case 'year':
            return `YEAR: ${s.getFullYear()} - ${e.getFullYear()}`;
          default:
            return `${s.toDateString()} - ${e.toDateString()}`;
        }
      };

      const title = formatDateRange(sdate, edate, selectedTimePeriod);

      // Row 1: CLIENT NAME
      worksheet.mergeCells('A1:G1');
      const headerCell = worksheet.getCell('A1');
      headerCell.value = `${selectedClient === 1 ? clientname : clientname.label}`;
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: 'center', vertical: 'middle' };

      // Row 2: TITLE
      worksheet.mergeCells('A2:G2');
      const titleCell = worksheet.getCell('A2');
      titleCell.value = title;
      titleCell.font = { bold: true, size: 12 };
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

      // Row 3: Headers
      worksheet.addRow(['Clients', 'Projects', 'Comments Date', 'Employees', 'Tasks', 'Comments', 'Hours']);
      worksheet.columns = [
        { key: 'client_name', width: 20 },
        { key: 'project_name', width: 20 },
        { key: 'comments_Date', width: 20 },
        { key: 'employee_name', width: 30 },
        { key: 'task_name', width: 40 },
        { key: 'comments_data', width: 60 },
        { key: 'Hours', width: 10 },
      ];
      worksheet.getRow(3).font = { bold: true };

      // Populate data rows
      let totalMinutes = 0;

      data.forEach((row) => {
        const [h, m] = row.Hours.split(':').map(Number);
        totalMinutes += h * 60 + m;

        worksheet.addRow({
          client_name: row.Client_name,
          project_name: row.projectName,
          comments_Date: row.comments_Date,
          employee_name: row?.Employee_Name,
          task_name: row?.taskName,
          comments_data: row.CommentContent,
          Hours: row.Hours,
        });
      });

      // Compute total hours as HH:MM
      const totalHours = `${String(Math.floor(totalMinutes / 60)).padStart(2, '0')}:${String(totalMinutes % 60).padStart(2, '0')}`;

      // Add total row
      const totalRow = worksheet.addRow(['', '', '', '', '', '', totalHours]);
      const rowNum = totalRow.number;

      // Merge A-E for label
      worksheet.mergeCells(`A${rowNum}:F${rowNum}`);
      const totalLabelCell = worksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = 'Overall Total';
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
      totalLabelCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' },
      };

      const totalValueCell = worksheet.getCell(`G${rowNum}`);
      totalValueCell.value = totalHours;
      totalValueCell.font = { bold: true };
      totalValueCell.alignment = { horizontal: 'right', vertical: 'middle' };
      totalValueCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' },
      };

      // Apply alignment and borders to all rows
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });

        if (rowNumber > 3 && rowNumber < rowNum) {
          row.eachCell((cell, colNumber) => {
            let horizontal = colNumber === 7 ? 'right' : 'left';
            cell.alignment = { horizontal, vertical: 'middle', wrapText: true };
          });
        }
      });

      // Export the Excel file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const capitalizedPeriod = selectedTimePeriod === "date" ? "Days" : `${selectedTimePeriod.charAt(0).toUpperCase() + selectedTimePeriod.slice(1)}ly`;
        const filename = `${capitalizedPeriod}_${selectedClient === 1 ? "All" : clientname.label}_Client_Report_${sdate}_to_${edate}.xlsx`;
        saveAs(new Blob([buffer]), filename);
      });
    } else {
      noDataWarning();
    }
  };





  useEffect(() => {
    const getAllClients = async () => {
      try {
        const storedClientIds = JSON.parse(localStorage.getItem('Emp_Assign_client')) || [];
        const Role_id = JSON.parse(localStorage.getItem('emp_role_id')) || [];

        const response = await Timesheetapi.get(`api/Projects/getclientname`);

        let clientOptions = response.data.Client
          .filter(project => {
            if (Role_id == 6) {
              return storedClientIds.includes(project.Client_id);
            }
            return true;
          })

          .map(project => ({
            value: project.Client_id,
            label: project.Client_name,
          }))
          .filter((item, index, self) =>
            index === self.findIndex(t => t.value === item.value)
          );
        clientOptions.unshift({ value: 1, label: 'All' });


        setAllClientList(clientOptions);

        console.log("CLIENTS ERROR IN PROJECT LIST", clientOptions);
        setSelectedClient(clientOptions[0]?.value);
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    };

    getAllClients();
  }, []);

  const parseDateString = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return isNaN(date) ? null : date;
  };

  const formatDateToDDMMYYYY = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
  };

  const getSelectedProjectDetails = (allProjectDetails) => {
    const finalResult = [];
    let totalMins = 0;

    allProjectDetails.forEach((project) => {
      const { Project_name, Tasks, Client_name, Client_id } = project;

      if (Tasks?.length > 0) {
        const groupedTasks = Tasks.reduce((acc, task) => {
          const itemId = task.ItemId;
          const employeeId = task.Emp_id;
          const compositeKey = `${itemId}_${employeeId}`; // key by both ItemId and Emp_id

          const hours = Number(task["Task+Hours"]);
          totalMins += hours;

          if (!acc[compositeKey]) {
            acc[compositeKey] = {
              itemId: itemId,
              taskName: task.ItemName,
              assignedTo: [employeeId],
              totalMins: hours,
              StartDate: task?.start_date || '-',
              EndDate: task?.end_date || '-',
              projectName: Project_name,
              Client_name: Client_name,
              Priority: task?.Priority || '-',
              Status: task?.Status,
              Employee_Name: task?.Employee_id, // name
              comments: task?.Task_comments || []
            };
          } else {
            acc[compositeKey].totalMins += hours;

            if (!acc[compositeKey].assignedTo.includes(employeeId)) {
              acc[compositeKey].assignedTo.push(employeeId);
            }

            if (task?.Task_comments?.length) {
              acc[compositeKey].comments.push(...task.Task_comments);
            }
          }

          return acc;
        }, {});

        const result = [];

        Object.values(groupedTasks).forEach((task) => {
          if (task.comments && task.comments.length > 0) {
            task.comments.forEach((comment) => {
              result.push({
                taskName: task.taskName,
                itemId: task.itemId,
                assignedTo: task.assignedTo.join(', '),
                StartDate: task?.StartDate,
                EndDate: task?.EndDate,
                TaskHours: formatTime(task.totalMins),
                CommentId: comment.CommentId,
                CommentContent: comment.content,
                Hours: comment.Comment_hrs,
                projectName: task.projectName.includes('/') ? task.projectName.split('/')[1].trim() : task.projectName,
                Client_name: task.Client_name,
                Client_id: Client_id,
                Employee_Name: task.Employee_Name,
                Status: task.Status,
                Priority: task.Priority,
                comments_Date: comment.comments_Date || '-'
              });
            });
          } else {
            result.push({
              taskName: task.taskName,
              itemId: task.itemId,
              assignedTo: task.assignedTo.join(', '),
              StartDate: task?.StartDate,
              EndDate: task?.EndDate,
              TaskHours: formatTime(task.totalMins),
              CommentId: '-',
              CommentContent: 'No comments',
              CommentHours: '00:00',
              projectName: task.projectName.includes('/') ? task.projectName.split('/')[1].trim() : task.projectName,
              Client_name: task.Client_name,
              Client_id: Client_id,
              Employee_Name: task.Employee_Name,
              Status: task.Status,
              Priority: task.Priority,
              comments_Date: task.Inprocess_date
            });
          }
        });

        finalResult.push(...result);
      }
    });

    console.log(totalMins, "finalResult");
    setRawData(finalResult);
    setTotalHours(formatTime(totalMins))
    setProjectList(finalResult);
  };



  useEffect(() => {
    console.log(selectedClientDetails, selectedClient, "selectedClient")
    if (selectedClientDetails?.length > 0 && selectedClient) {
      const Role_id = JSON.parse(localStorage.getItem('emp_role_id')) || [];
      const Emp_Assign_project = JSON.parse(localStorage.getItem('Emp_Assign_project')) || [];

      let filter = [];

      if (Role_id == 64) {
        filter = selectedClientDetails.filter((items) =>
          Emp_Assign_project.includes(Number(items.Project_id))
        );
      } else {
        filter = selectedClientDetails;
      }

      console.log("Emp_Assign_project", selectedClientDetails, filter)
      getSelectedProjectDetails(filter);
    } else {
      setProjectList([]);
      //setTotalHours(formatTime(0));
    }
  }, [selectedClientDetails]);




  useEffect(() => {

    if (selectedClient != "" && selectedClient != undefined && rawData.length > 0) {

      let filter = rawData.filter(item => selectedClient == 1 || item.Client_id == selectedClient);

      console.log("filter", filter, selectedClient, rawData)
      setProjectList(filter);
      // setSelectedTimePeriod('week');
    }

  }, [selectedClient])

  const handleExportVisibleData = () => {
    if (tableRef.current) {
      const visibleRows = tableRef.current.getPaginationRowModel().rows;
      const exportData = visibleRows.map(row => row.original);
      console.log('DATA TO BE EXPORTED', exportData)

      handleExportData(
        exportData,
        sDate,
        eDate,
        selectedTimePeriod
      );
    }
  };

  const parseTime = (hhmm) => {
    const [hours, minutes] = hhmm.split(':').map(Number);
    return hours * 60 + minutes;
  };


  return (
    <>
      {contextHolder}
      <section className='reports-section'>
        <div className="flex items-center justify-between mt-[38px] pr-[0px]" style={{ marginBottom: '-5px' }}>
          <div>
            <h2 className="page-heading">HOURS BY CLIENT</h2>
          </div>
          {
            !loading && (

              <Button className="bg-[#3b82f6] text-[#fff] h-[33px] w-[110px]" style={{ paddingInline: '8px 10px' }}
                // onClick={() =>
                //   handleExportData(table.getPrePaginationRowModel().rows)
                // } startIcon={<FileDownloadIcon />}
                onClick={handleExportVisibleData}
              >
                <FileDownloadIcon style={{ fontSize: '18px' }} /> Export
              </Button>
            )
          }
        </div>
        <div className="flex justify-start">
          <div>
            <Select className="z-[99] left-[10px] top-[24px]"
              style={{ width: 150 }}
              placeholder="Select Client"
              value={selectedClient}
              showSearch
              optionFilterProp="label"
              onChange={handleClientChange}
              disabled={loading}
              options={allClientList || []}
            />
          </div>
          <div className="flex justify-start gap-[10px]">
            <Select className="z-[99] left-[20px] top-[24px]"
              style={{ width: 150 }}
              placeholder="Time Period"
              value={selectedTimePeriod}
              options={options}
              onChange={handleTimePeriodChange}
              disabled={loading}
            />

            <div style={{ left: "100px" }}>
              {selectedTimePeriod === 'month' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={[dayjs().startOf('month'), dayjs().endOf('month')]}
                  picker="month"
                  placeholder={['Start Month', 'End Month']}
                  format="MMMM YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    // Disable future months
                    return current && current > dayjs().endOf('month');
                  }}
                />
              )}
              {selectedTimePeriod === 'year' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={[dayjs().startOf('year'), dayjs().endOf('year')]}
                  picker="year"
                  placeholder={['Start Year', 'End Year']}
                  format="YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    // Disable future years
                    return current && current.year() > dayjs().year();
                  }}
                />
              )}
              {selectedTimePeriod === 'date' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={[dayjs().startOf('day'), dayjs().endOf('day')]}
                  placeholder={['Start Date', 'End Date']}
                  format="DD-MM-YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    // Disable future dates
                    return current && current > dayjs().endOf('day');
                  }}


                />
              )}

              {selectedTimePeriod === 'week' && (
                <Flatpickr
                  className={`ant-select ant-select-outlined z-[99] left-[20px] top-[24px] w-[235px] date-picker-client-report ${loading ? 'date-picker-client-report-disabled' : 'date-picker-client-report'}`}
                  value={selectedWeekDates}
                  options={{
                    mode: "range",
                    dateFormat: "D, M j",
                    onChange: (selectedDates, DaysDate, instance) => { handleWeekSelection(selectedDates, instance); },
                    disable: [
                      function (date) {
                        const week_selectedDate = today;
                        const week_startOfWeek = new Date(week_selectedDate);
                        const week_dayOfWeek = week_startOfWeek.getDay();
                        const daysToMonday = week_dayOfWeek == 0 ? 6 : week_dayOfWeek - 1;
                        week_startOfWeek.setDate(week_startOfWeek.getDate() - daysToMonday);
                        const week_endOfWeek = new Date(week_startOfWeek);
                        week_endOfWeek.setDate(week_startOfWeek.getDate() + 6);

                        console.log(week_dayOfWeek, date, "week_endOfWeek")
                        return date > week_endOfWeek;
                      }
                    ],
                    // 
                  }}
                  noCalendar={loading}
                  placeholder="Select Week"
                />
              )}
            </div>

          </div>
        </div>
        <div className="mt-[-20px]  custom-table custom-project-table">
          {
            loading ? (<>
              <Spin tip="Loading..." className="justify-center items-center flex" style={{ height: '100vh' }}>
                <CustomTable
                  columns={columns}
                  data={[]} // totalRow
                  component={"Allocation"}
                  handleExportData={handleExportData}
                  hours={totalHours}
                />

              </Spin>
            </>

            ) : (
              <>
                <CustomTable
                  columns={columns}
                  data={[...projectList]}
                  component={"Allocation"}
                  handleExportData={handleExportData}
                  hours={totalHours}
                  onTableInstance={(instance) => {
                    tableRef.current = instance;
                  }}
                  setTotalHours={setTotalHours}
                  FormatTime={formatTime}
                  sidebor={sidebor}
                />
              </>
            )}

        </div>
      </section>
    </>
  );
}
